import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import TwoFactorIcon from "../../assets/images/2fa.png";
import $ from "jquery";
import fileDownload from "js-file-download";
let o = {
  AdminCount: 0,
  CredentialText: "",
  DomainBox: "",
  DomainId: 0,
  DomainName: null,
  ExternalId: "",
  IDs: [],
  Id: null,
  IsCsrOrg: false,
  IsEpicOrganization: false,
  KeepMDN: false,
  NPI: "",
  OrgEmailCount: 0,
  OrganizationKind: null,
  OrganizationName: "",
  OrganizationType: "",
  /*OutOfNetwork: false,*/
  ParentOrg: "",
  ParentOrganizationId: null,
  ParentOrganizationName: null,
  Specialties: [],
  Addresse: {
    FirstLine: "",
    SecondLine: "",
    City: "",
    State: "",
    County: "",
    PostalCode: "",
    Country: "",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
    AddressType: 0,
    IsCertAddress: true,
  },
  SubOrgCount: 0,
  UserCount: 0,
  UserEmailCount: 0,
  VendorId: 0,
  VendorVal: "",
  XDRDoNOTGenerateXDM: false,
  XDREnabled: false,
  xdrConfig: null,
  AllowTwoFactor: false,
  ApplicationAccessXDR: false,
  /*  ApplicationAccessENS: false,*/
  specializationCode: "",
};
const DetailsOrg = ({ orgDetails, CloseDetailOrg, customerName, orgEdit }) => {
  const navigate = useNavigate();
  const {
    userRole,
    userToken,
    setCustomerObj,
    sharedObject,
    SetSharedObject,
    XdrArr,
    userSession,
    setSearchObj,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    setCustomerObj: state.setCustomerObj,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    XdrArr: state.XdrArr,
    userSession: state.userSession,
    setSearchObj: state.setSearchObj,
  }));
  const [processingDetails, SetProcessingDetails] = useState(false);
  const [addressObject, SetAddressObject] = useState({});
  const [specailityObject, SetSpecailityObject] = useState({});
  const [PINValue, SetPINValue] = useState("");
  const [IDsValue, SetIDsValue] = useState("");
  const [secondValue, SetSecondValue] = useState("");
  const [thirdValue, SetThirdValue] = useState("");
  const [addIdFlag, SetIdFlag] = useState(false);
  const [collapse, SetCollapse] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [XDRConfigObj, setXDRArrConfigObj] = useState({});
  const [DirectRoute, SetDirectRoute] = useState(false);
  const [AdvancedDirectRoute, SetAdvancedDirectRoute] = useState(false);
  //const [custInfo, SetCustInfo] = useState([]);
  const [custCheckboxes, SetCustCheckboxes] = useState({});
  const [permissions, SetPermissions] = useState({});
  const [notExists, SetNotExists] = useState(true);
  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  useEffect(() => {
    SetNotExists(true);
    SetSharedObject("CSRUploadPage", "");
    setAnswers(orgDetails);
    if (orgDetails.EmailForwardingType === 1) {
      SetDirectRoute(true);
      SetAdvancedDirectRoute(false);
    } else if (orgDetails.EmailForwardingType === 2) {
      SetDirectRoute(false);
      SetAdvancedDirectRoute(true);
    } else {
      SetDirectRoute(false);
      SetAdvancedDirectRoute(false);
    }
    SetErrCreateMsg(false);
    SetSharedObject("orgActionObj", orgDetails);
    if (orgDetails) {
      SetAddressObject(orgDetails?.addresses[0]);
      SetSpecailityObject(orgDetails?.specialties[0]);
      GetXdrConfig(orgDetails?.xdrConfig?.id);
    }
    customerPermission(orgDetails?.vendorId);
  }, [orgDetails]);
  const customerPermission = (customerId) => {
    var customer = sharedObject.vendorsObj.find((element) => {
      return element.id === parseInt(customerId);
    });

    var ob = {
      ApplicationAccessXDR: customer?.applicationAccessXDR,
      ApplicationAccessENS: customer?.applicationAccessENS,
      TwoFactorAuth: customer?.twoFactorAuth,
      EmailForwardingType: customer?.emailForwardingType,
      ShareDirectoryListing: customer?.directorySharing,
    };
    if (
      ob.emailForwardingType === 0 &&
      ob.twoFactorAuth === false &&
      ob.applicationAccessXDR === false &&
      ob.applicationAccessENS === false &&
      ob.directorySharing === false
    ) {
      SetPermissions(true);
    } else {
      SetPermissions(false);
    }
    SetCustCheckboxes(ob);
  };

  const GetXdrConfig = async (vl) => {
    let tempXDR = {};
    if (vl) {
      for (let el of XdrArr) {
        if (el.id === parseInt(vl)) {
          tempXDR = el;
          break;
        }
      }
    }
    await setXDRArrConfigObj(tempXDR);
  };
  const viewPIN = async () => {
    SetProcessingDetails(true);
    let call = "/organization/ViewPin?orgId=" + answers.id;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetPINValue(res.data.data);
      $("#TlsPinModal").modal("show");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      let str = "We could not find a pin for this organization.";
      SetMsg(str);
      SetErrCreateMsg(true);
      SetProcessingDetails(false);
    }
  };
  const DeleteId = async (el) => {
    SetProcessingDetails(true);
    let call =
      "/organization/DeleteOrgId?orgId=" +
      answers.id +
      "&RecordId=" +
      el.recordId;
    const res = await CallAPI(call, null, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      orgEdit(answers, "orgSearch");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessingDetails(false);
    }
  };
  const orgEditHandle = async (obj) => {
    SetProcessingDetails(true);
    await orgEdit(obj, "orgSearch");
    SetProcessingDetails(false);
  };
  const SearchNpi = async (valId) => {
    SetProcessingDetails(true);
    SetNotExists(true);
    let flag = false;
    let call = "/organization/SearchNPI?searchNPI=" + valId + "&npiType=1";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      if (dt && Object.keys(dt).length > 0 && dt.constructor === Object) {
        SetNotExists(true);
        flag = true;
      } else {
        SetNotExists(false);
        flag = false;
      }
    } else if (res.status === "SERVERERROR") {
      SetNotExists(false);
      SetProcessingDetails(false);
      flag = false;
    }
    SetProcessingDetails(false);
    return await flag;
  };
  const AddId = async () => {
    SetIdFlag(true);
    let IdType = IDsValue === "NPI" ? 0 : IDsValue === "State" ? 1 : 2;
    if (IDsValue === "NPI") {
      let npiFlag = await SearchNpi(secondValue);
      if (!npiFlag) return;
    }
    let obj = {
      RecordId: 0,
      IDType: IdType,
      Value: IDsValue === "State" ? thirdValue : secondValue,
      IssuingAuthority: IDsValue === "State" ? secondValue : thirdValue,
    };
    SetProcessingDetails(true);
    let call = "/organization/addOrgId?orgId=" + answers.id;
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetIDsValue("");
      SetSecondValue("");
      SetThirdValue("");
      SetIdFlag(false);
      orgEdit(answers, "orgSearch");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessingDetails(false);
    }
  };
  function isNumeric(n) {
    return (!isNaN(parseFloat(n)) && isFinite(n)) || n === "" || n === ".";
  }
  const [uncheckMsg, SetUncheckMsg] = useState(false);
  const UncheckCSR = async () => {
    SetProcessingDetails(true);
    SetUncheckMsg(false);
    let call = "/organization/DeleteCSRCert?orgId=" + answers.id;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      if (res.data.data === "notExists") {
        SetMsg("TLS Certificate does not exists.");
        SetUncheckMsg(true);
      }
      SetSharedObject("CSRUploadFlag", false);
      let det = { ...sharedObject.orgActionObj, isCsrOrg: false };
      SetSharedObject("orgActionObj", det);
      $("#UncheckCSRmodal").modal("hide");
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      // let msg = res.data.data;
      // if (Object.keys(msg).length > 0 && msg.constructor === Object) {
      //   let str = "<div>";
      //   for (let el in msg) {
      //     str += `${el}`;
      //   }
      //   str += "</div>";
      SetMsg(
        "A system error occurred searching for your results. Please contact support for further assistance."
      );
      // } else {
      //   SetMsg(msg);
      // }
      SetErrCreateMsg(true);
      SetProcessingDetails(false);
    }
  };

  const [flag, setFlag] = useState(false);
  const getCustomer = () => {
    var obj = sharedObject.vendorsObj;
    var customer;
    for (var i = 0; i < obj.length; i++) {
      var c = obj[i];
      if (c.name == customerName) {
        customer = c;
      }
    }
    $("#detailsOrgModal").modal("hide");
    SetSharedObject("CustomerObj", customer);
    setFlag("/customers");
  };
  const [createUser, setCreateUser] = useState(false);
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
    setCreateUser(
      userSession?.CreateUserFlag || userRole === "SES ADMINISTRATOR"
    );
  }, [flag, navigate]);

  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [msg, SetMsg] = useState(false);
  const downloadTLS = async () => {
    SetProcessingDetails(true);
    let call = "/organization/DownloadOrgTLS?orgId=" + answers.id;
    const res = await CallAPI(call, null, "post", userToken, false, true);
    await SetSharedObject("ResponseCode", res.code);
    SetProcessingDetails(false);
    if (res.status === "SUCCESS") {
      let fileName = answers.organizationName + ".pfx";
      let file = res.data.data;
      console.log(file.fileContents);
      fileDownload(file.fileContents, fileName);
      SetProcessingDetails(false);
    } else if (res.status === "SERVERERROR") {
      let msg =
        "Could not generate a TLS cert for: " + answers.organizationName;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetProcessingDetails(false);
    }
  };
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const TwoFactorSignUp = async () => {
    $("#TwoFactorSignupModal").modal("show");
  };
  return (
    <div className="DetailsOrg">
      <div
        className="modal fade"
        id="detailsOrgModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsOrganization"
        //aria-hidden="true"
        style={{ zIndex: "1061 !important" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                Details
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={CloseDetailOrg}
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>

            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <i className="bi bi-building-fill text-size5"></i>
                    <div className="text-size6 ft-wt ">
                      {answers?.organizationName}
                    </div>
                    <div className="sp-margin1">
                      <i className="bi bi-pencil-square sp-margin5"></i>
                      <a
                        href="javascript:void(0);"
                        onClick={(el) => orgEdit(answers, false)}
                      >
                        EDIT
                      </a>
                    </div>
                  </div>
                  <section>
                    <div>
                      <label for="address">Address:</label>
                      <span className="sp-margin5 spacer-inline">
                        {addressObject?.firstLine},
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {addressObject?.secondLine}
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {addressObject?.city},
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {addressObject?.state} {addressObject?.postalCode}
                      </span>
                    </div>
                    <div>
                      <label for="phone">Phone:</label>
                      <span>
                        {formatPhoneNumber(
                          addressObject?.phone?.substring(0, 10)
                        )}
                      </span>
                      <label for="phone.ext" className="sp-margin12">
                        Ext:
                      </label>
                      <span>
                        {addressObject?.phone?.length > 10
                          ? addressObject?.phone?.substring(
                              10,
                              addressObject?.phone.length
                            )
                          : ""}
                      </span>
                      <br />
                      <label for="fax.ext" className="sp-margin5">
                        Fax:
                      </label>
                      <span>
                        {formatPhoneNumber(
                          addressObject?.fax?.substring(0, 10)
                        )}
                      </span>
                      <label className="sp-margin12">Ext:</label>
                      <span className="sp-margin5">
                        {addressObject?.fax?.length > 10
                          ? addressObject?.fax?.substring(
                              10,
                              addressObject?.fax.length
                            )
                          : ""}
                      </span>
                    </div>
                  </section>
                  <hr />
                  {/*User Info*/}
                  <section className="field-wrapper">
                    {userRole !== "SES ADMINISTRATOR" ? null : (
                      <div>
                        <label for="domain">Customer:</label>
                        <Link
                          onClick={() => {
                            getCustomer();
                          }}
                          title="Customer Link"
                        >
                          <span> {customerName} </span>
                        </Link>
                      </div>
                    )}
                    <div>
                      <label for="domain">Domain:</label>
                      <span> {answers.domainName} </span>
                    </div>
                    {answers.parentOrganizationId !== 1 ? (
                      <div>
                        <label for="ParentOrg">Parent Organization:</label>
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            let ob = {
                              id: answers.parentOrganizationId,
                              OrganizationName: answers.parentOrganizationName,
                              ShowParent: "ShowParent",
                            };
                            orgEditHandle(ob);
                          }}
                          title="Organization Link"
                        >
                          <span>{answers.parentOrganizationName}</span>
                        </a>
                        <br />
                      </div>
                    ) : null}
                    <label for="OrgType">Organization Type:</label>
                    <span>{answers.organizationType}</span>
                    <br />
                    <label for="external_id">External ID:</label>
                    <span>{answers.externalId}</span>
                    <br />
                    <label for="CreatedBy">Created By:</label>
                    <span>{answers?.createdBy?.split("|")[0]}</span>
                    <br />
                    <label for="DateCreated">Date Created:</label>
                    <span>
                      {answers?.dateCreated
                        ? new Date(answers?.dateCreated).toLocaleString()
                        : null}
                    </span>
                    <br />
                    <label for="specialty">Specialty</label>
                    <div className="sub-catg">
                      <label for=" SpecialtyType">Type:</label>
                      <span> {specailityObject?.type}</span>
                      <br />
                      <label for=" classNameification">Classification:</label>
                      <span>{specailityObject?.classification}</span>
                      <br />
                      <label for=" Specialization">Specialization:</label>
                      <span>{specailityObject?.specialization}</span>
                    </div>
                    <br />

                    <div className="sp-margin3">
                      <label>TOTAL AVAILABLE</label>
                    </div>
                    <div className="total-av-container">
                      <div className="total-av-wrapper">
                        <a
                          href="javascript:void(0);"
                          onClick={(e) => {
                            let o = {
                              ...orgDetails,
                              Name: orgDetails.organizationName,
                              Type: "sub",
                              OrgType: "org",
                              VendorId: orgDetails.vendorId,
                            };
                            //SetSharedObject("CustomerPermissionsObj", o);
                            setCustomerObj(o);
                            SetSharedObject("orgActionObj", o);
                            $("#detailsOrgModal").modal("hide");
                            navigate("/organization-registration");
                          }}
                        >
                          <div
                            class="circle-plus"
                            alt="Plus Icon"
                            title="Add Org"
                          >
                            +
                          </div>
                        </a>
                        <div className="suborg-av">
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => {
                              $("#detailsOrgModal").modal("hide");
                              if (answers?.subOrgCount > 0) {
                                orgEdit(answers, false, true);
                              }
                            }}
                            type="button"
                            className="btn btn-success"
                          >
                            <i
                              className="fas fa-building"
                              alt="Building Icon"
                              title="Organization List"
                            ></i>
                          </a>
                        </div>
                        <div className="totalnumber">
                          Orgs: {answers?.subOrgCount}
                        </div>
                      </div>

                      <div className="total-av-wrapper">
                        {createUser === true ||
                        userRole === "SES ADMINISTRATOR" ? (
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => {
                              SetSharedObject(
                                "orgObjectTFA",
                                answers?.twoFactorAuth
                              );
                              let o = {
                                OrganizationId: answers.id,
                                Name: answers.organizationName,
                                Navigate: "org",
                                Flag: "userOrgDetails",
                                AdminsOnly: false,
                              };

                              $("#detailsOrgModal").modal("hide");
                              SetSharedObject(
                                "orgActionObjForUser",
                                orgDetails
                              );
                              SetSharedObject("orgActionObj", orgDetails);
                              navigate("/user-registration");
                            }}
                          >
                            <div
                              class="circle-plus"
                              alt="Plus Icon"
                              title="Add User"
                            >
                              +
                            </div>
                          </a>
                        ) : (
                          <div
                            class="circle-plus-disabled"
                            alt="Plus Icon"
                            title="Not Enabled"
                          >
                            +
                          </div>
                        )}
                        <div className="users-av">
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => {
                              SetSharedObject(
                                "orgObjectTFA",
                                answers?.twoFactorAuth
                              );
                              if (answers?.userCount > 0) {
                                $("#detailsOrgModal").modal("hide");
                                let o = {
                                  OrganizationId: answers.id,
                                  Name: answers.organizationName,
                                  Navigate: "org",
                                  Flag: "userOrgDetails",
                                  AdminsOnly: false,
                                };
                                SetSharedObject("UserIdEmail", o);
                                navigate("/users");
                              }
                            }}
                            type="button"
                            className="btn btn-success"
                          >
                            <i
                              className="fas fa-users"
                              alt="User Icon"
                              title="User List"
                            ></i>
                          </a>
                        </div>
                        <div className="totalnumber">
                          Users: {answers?.userCount}
                        </div>
                      </div>
                      <div className="total-av-wrapper">
                        <a
                          href="javascript:void(0);"
                          onClick={(e) => {
                            let o = {
                              ...answers,
                              Id: orgDetails.id,
                              Name: answers.organizationName,
                              Navigate: "orgEmails",
                              Flag: "orgEmails",
                              Domain: answers.domainName,
                            };
                            SetSharedObject("UserIdEmail", o);
                            SetSharedObject("sharedObject", o);
                            $("#detailsOrgModal").modal("hide");
                            navigate("/emails");
                          }}
                        >
                          <div
                            class="circle-plus"
                            alt="Plus Icon"
                            title="Add Email"
                          >
                            +
                          </div>
                        </a>
                        <div className="org-emails-av">
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => {
                              if (answers?.orgEmailCount > 0) {
                                let o = {
                                  ...answers,
                                  Id: orgDetails.id,
                                  Name: answers.organizationName,
                                  Navigate: "orgEmails",
                                  Flag: "orgEmails",
                                  Domain: answers.domainName,
                                };
                                SetSharedObject("UserIdEmail", o);
                                SetSharedObject("sharedObject", o);
                                $("#detailsOrgModal").modal("hide");
                                navigate("/emails");
                              }
                            }}
                            type="button"
                            className="btn btn-success"
                          >
                            <i
                              className="fas fa-envelope"
                              alt="Email Icon"
                              title="Emal List"
                            ></i>
                          </a>
                        </div>
                        <div className="totalnumber">
                          Emails: {answers?.orgEmailCount}
                        </div>
                      </div>
                      <div className="total-av-wrapper">
                        <div className="admin-av">
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => {
                              if (answers?.adminCount > 0) {
                                let o = {
                                  //...sharedObject.UserIdEmail,
                                  OrganizationId: answers.id,
                                  Name: answers.organizationName,
                                  Navigate: "org",
                                  Flag: "adminUserOrgDetails",
                                  AdminsOnly: true,
                                };
                                SetSharedObject("UserIdEmail", o);
                                $("#detailsOrgModal").modal("hide");
                                navigate("/users");
                              }
                            }}
                            type="button"
                            className="btn btn-success"
                            id=""
                          >
                            <i
                              className="fas fa-users-cog"
                              alt="Admin Icon"
                              title="Admin List"
                            ></i>
                          </a>
                        </div>
                        <div className="totalnumber">
                          Admins: {answers?.adminCount}
                        </div>
                      </div>
                    </div>
                  </section>

                  {/*Services */}
                  <section className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">Permissions</div>
                  </section>
                  {permissions === true ? (
                    <div className="sub-catg ctr">
                      There are no permissions for this organization.
                    </div>
                  ) : null}
                  <div className="field-wrapper">
                    <div>
                      <label>Two-Factor Authentication:</label>
                      {custCheckboxes.TwoFactorAuth ? (
                        <span>
                          {answers?.twoFactorAuth === true
                            ? "Enabled"
                            : "Disabled"}
                        </span>
                      ) : (
                        <a
                          href=" javascript:void(0);"
                          className="btn btn-outline-info"
                          onClick={TwoFactorSignUp}
                        >
                          Learn More
                        </a>
                      )}
                    </div>

                    <section>
                      {custCheckboxes.ApplicationAccessXDR ? (
                        <div>
                          <label>XDR-Access:</label>
                          <span>
                            {answers.applicationAccessXDR
                              ? "Enabled"
                              : "Disabled"}
                          </span>
                        </div>
                      ) : null}
                      {custCheckboxes.ShareDirectoryListing ? (
                        <div>
                          <label>Share Directory Listings:</label>
                          <span>
                            {answers?.shareDirectoryListing
                              ? "Enabled"
                              : "Disabled"}
                          </span>
                          <br />
                        </div>
                      ) : null}

                      {custCheckboxes.ApplicationAccessENS ? (
                        <div>
                          <label>Notify:</label>
                          <span>
                            {answers?.applicationAccessENS
                              ? "Enabled"
                              : "Disabled"}
                          </span>
                          <br />
                        </div>
                      ) : null}
                      {custCheckboxes.EmailForwardingType &&
                      custCheckboxes?.EmailForwardingType === 1 ? (
                        <>
                          <div>
                            <label>DirectRoute:</label>
                            <span>
                              {answers?.emailForwardingType === 1
                                ? "Enabled"
                                : "Disabled"}
                            </span>
                            <br />
                          </div>{" "}
                        </>
                      ) : null}
                      {custCheckboxes.EmailForwardingType &&
                      custCheckboxes?.EmailForwardingType === 2 ? (
                        <>
                          <div>
                            <label>Advanced DirectRoute:</label>
                            <span>
                              {answers?.emailForwardingType === 2
                                ? "Enabled"
                                : "Disabled"}
                            </span>
                          </div>
                        </>
                      ) : null}
                    </section>
                  </div>

                  {/*Email Delivery*/}
                  <div className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">
                      Email Delivery
                    </div>
                  </div>
                  <div className="field-wrapper">
                    <label for="KeepMDN">Keep MDN:</label>
                    <span> {answers.keepMDN ? "Yes" : "No"}</span>
                    <br />
                    <section>
                      {" "}
                      {custCheckboxes.ApplicationAccessXDR &&
                      answers.applicationAccessXDR ? (
                        <>
                          {custCheckboxes.ApplicationAccessXDR ? (
                            <>
                              <label for="OutboundXDR">Inbound XDR:</label>
                              <span>
                                {answers.xdrEnabled ? "Enabled" : "Disabled"}
                              </span>
                              <div
                                className="sub-catg"
                                hidden={!answers.xdrEnabled}
                              >
                                <label for=" ConfigName">Config Name:</label>
                                <span> {XDRConfigObj.endpointName}</span>
                                <br />
                                <label for=" EndpointUrl">Endpoint URL:</label>
                                <span className="word-set">
                                  {XDRConfigObj.endpointAddress}
                                </span>
                                <br />
                                <label for="ReceiveMDN">Deliver MDN:</label>
                                <span>
                                  {XDRConfigObj.mdnForward ? "Yes" : "No"}
                                </span>
                                <br />
                                <label for="">
                                  Deliver Message Body for XDM Messages:
                                </label>
                                <span>
                                  {XDRConfigObj.sendXDMBody ? "Yes" : "No"}
                                </span>
                              </div>
                              <br />
                            </>
                          ) : null}
                          {answers.applicationAccessXDR ? (
                            <>
                              <label for="InboundXDR">Outbound XDR</label>
                              <br />
                            </>
                          ) : null}
                          <div className="sub-catg">
                            <label for="ReceiveMDN">
                              Create Direct Automatically:
                            </label>
                            <span>
                              {answers.isEpicOrganization ? "Yes" : "No"}
                            </span>

                            {/*<br />*/}
                            {/*<label for=" Oon">Out of Network:</label>*/}
                            {/*<span>{answers.outOfNetwork ? "Yes" : "No"}</span>*/}
                            <br />
                            <label for=" XdmDeliver">XDM Delivery:</label>
                            <span>
                              {!answers.xdrDoNOTGenerateXDM ? "Yes" : "No"}
                            </span>
                          </div>
                        </>
                      ) : null}
                    </section>
                  </div>

                  {/*Certificates*/}
                  <div className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">Certificates</div>
                    <div className="sp-margin3 spacer-inline float-r">
                      <details data-popover="up">
                        <summary>
                          <i className="bi bi-info-circle text-size9"></i>
                        </summary>
                        <div>
                          <div className="icon-sign or-clr">
                            <i className="bi bi-info-circle"></i>
                          </div>
                          <p className="sp-margin4">
                            Transport Layer Security (TLS) and its predecessor,
                            Secure Sockets Layer (SSL), both frequently referred
                            to as 'ssl', are cryptographic protocols that
                            provide communications security over a computer
                            network.
                          </p>
                          In Public Key Infrastructure (PKI) systems, a
                          Certificate Signing Request (also CSR or certification
                          request) is a message sent from an applicant to a
                          Certificate Authority in order to apply for a digital
                          identity certificate.
                        </div>
                      </details>
                    </div>
                  </div>
                  <div className="field-wrapper">
                    <div>
                      <label>Type:</label>
                      <span>
                        {orgDetails.tlsCertExists
                          ? "SES Generated (TLS)"
                          : null}
                      </span>
                    </div>
                    <div>
                      <label>Enable CSR Upload:</label>
                      <input
                        type="checkbox"
                        name="IsCsrOrg"
                        checked={sharedObject.CSRUploadFlag}
                        value={sharedObject.CSRUploadFlag}
                        onChange={(el) => {
                          //setAnswer("IsCsrOrg", el.target.checked);
                          //SetSharedObject("CSRUploadFlag", el.target.checked);
                          SetSharedObject("CSRUploadPage", "Enable");
                          if (!el.target.checked) {
                            $("#UncheckCSRmodal").modal("show");
                          } else {
                            $("#orgCSRModal").modal("show");
                          }
                        }}
                      />
                    </div>
                    <label>Organization TLS Cert:</label>
                    {/* <a href={answers.OrgTLSCert}>*/}
                    <a
                      href="javascript:void(0);"
                      onClick={(el) => downloadTLS()}
                      data-toggle="modal"
                    >
                      Download
                    </a>
                    {sharedObject.CSRUploadFlag ? (
                      <>
                        {" "}
                        |{" "}
                        <a
                          href="javascript:void(0);"
                          onClick={(el) => {
                            SetSharedObject("CSRUploadPage", "Replace");
                            $("#orgCSRModal").modal("show");
                          }}
                          data-toggle="modal"
                        >
                          Replace CSR
                        </a>
                      </>
                    ) : null}
                    <br />
                    <label>PIN for TLS Cert:</label>
                    <a
                      href="javascript:void(0);"
                      onClick={(el) => viewPIN()}
                      data-toggle="modal"
                    >
                      View
                    </a>
                    {errCreateMsg ? (
                      <div className={`alert alert-danger`}>{msg}</div>
                    ) : null}
                  </div>

                  {/*ID Info*/}
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">ID</div>
                    <div className="v-set2 spacer-inline float-r">
                      <a
                        href="javascript:void(0);"
                        className="btn btn-info min-wsm"
                        onClick={(el) => {
                          SetCollapse(!collapse);
                        }}
                        role="button"
                        aria-controls="ID-form"
                      >
                        <i
                          className={`bi ${!collapse ? "bi-plus" : "bi-dash"}`}
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div
                    id="ID-form"
                    className={`field-wrapper ${!collapse ? "collapse" : null}`}
                  >
                    <select
                      className="form-control w-md2 sp-margin13 spacer-inline sp-margin5"
                      onChange={(el) => {
                        SetIDsValue(el.target.value);
                        SetSecondValue("");
                        SetNotExists(true);
                        if (el.target.value === "NPI") {
                          SetThirdValue("CMS");
                        } else {
                          SetThirdValue("");
                        }
                      }}
                    >
                      <option value={""}>Select</option>
                      <option value={"NPI"}>NPI</option>
                      <option value={"State"}>State License</option>
                      <option value={"Other"}>Other</option>
                    </select>
                    {IDsValue === "State" ? (
                      <>
                        <select
                          className="form-control w-md2 sp-margin13 spacer-inline"
                          value={secondValue}
                          onChange={(el) => SetSecondValue(el.target.value)}
                        >
                          <option value={""}>Issuing State</option>
                          {stateCodeArray.map((el) => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </select>
                        <input
                          className="form-control sp-margin13"
                          type="text"
                          placeholder="Enter Value"
                          value={thirdValue}
                          onChange={(el) => SetThirdValue(el.target.value)}
                        />
                      </>
                    ) : IDsValue === "" ? null : (
                      <>
                        <input
                          className="form-control w-md2 sp-margin13 spacer-inline"
                          maxLength={IDsValue === "NPI" ? 10 : 16}
                          value={secondValue}
                          onChange={(el) => {
                            let vl = el.target.value;
                            let chk = isNumeric(vl);
                            if (chk && IDsValue === "NPI") {
                              SetSecondValue(el.target.value);
                            } else if (IDsValue === "Other") {
                              SetSecondValue(el.target.value);
                            }
                          }}
                          type={IDsValue === "NPI" ? "tel" : "text"}
                          placeholder={
                            IDsValue === "NPI"
                              ? "10 digit number"
                              : "Enter Value"
                          }
                        />
                        <input
                          className="form-control sp-margin13"
                          type="text"
                          disabled={IDsValue === "NPI"}
                          value={thirdValue}
                          onChange={(el) => SetThirdValue(el.target.value)}
                          placeholder={
                            IDsValue === "NPI"
                              ? "CMS"
                              : " Enter Issuing Authority"
                          }
                        />
                      </>
                    )}
                    {!notExists ? (
                      <div className="alert alert-danger">
                        We could not connect or find NPI {secondValue} you
                        entered. Please double check your number and try again.
                      </div>
                    ) : null}
                    {addIdFlag &&
                    IDsValue === "NPI" &&
                    secondValue.length < 10 ? (
                      <div className="alert alert-danger">
                        NPI must have 10 numbers.
                      </div>
                    ) : null}
                    {addIdFlag &&
                    ((IDsValue === "State" && thirdValue === "") ||
                      (IDsValue === "Other" && secondValue === "")) ? (
                      <div className="alert alert-danger">
                        ID value is required.
                      </div>
                    ) : null}
                    <button
                      className="btn btn-success sp-margin13"
                      type="button"
                      disabled={
                        IDsValue === ""
                          ? true
                          : IDsValue === "NPI" && secondValue.length < 10
                          ? true
                          : IDsValue === "State" &&
                            (secondValue === "" || thirdValue === "")
                          ? true
                          : IDsValue === "Other" && secondValue === ""
                          ? true
                          : false
                      }
                      onClick={(e) => AddId()}
                    >
                      Add
                    </button>
                  </div>
                  <table className="o-flow">
                    <tr>
                      <th className="w-sm">Type</th>
                      <th>Value</th>
                      <th>Issuing Authority</th>
                      <th className="ctr">Remove</th>
                    </tr>
                    {answers?.iDs?.map((el) => (
                      <tr key={el.recordId}>
                        <td>{el.idTypeString}</td>
                        <td>{el.value}</td>
                        <td>{el.issuingAuthority}</td>
                        <td
                          className="ctr click-box"
                          onClick={(e) => DeleteId(el)}
                        >
                          <i className="bi bi-x-circle rd-clr"></i>
                        </td>
                      </tr>
                    ))}
                  </table>
                  {answers?.iDs?.length === 0 ? (
                    <div className="sub-catg">
                      There are no IDs created for this user.
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                  onClick={CloseDetailOrg}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/*Certificate Uncheck CSR Upload Confirmation*/}
      <div
        className="modal fade"
        id="UncheckCSRmodal"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Confirmation"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title or-clr">Attention!</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="descript2-container">
                Unchecking this option will delete current CSR-based certificate
                and default back to TLS Certificate from this organization.
              </div>
              {uncheckMsg ? (
                <div className={`alert alert-danger`}>{msg}</div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={(e) => UncheckCSR()}
              >
                Confirm
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
                onClick={(e) => {
                  $("#UncheckCSRmodal").modal("hide");
                  SetSharedObject("CSRUploadFlag", true);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*Certificate section for TLS Cert Pin*/}
      <div
        className="modal fade"
        id="TlsPinModal"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Confirmation"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Organization TLS PIN</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body ctr">
              <label>{PINValue}</label>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="TwoFactorSignupModal"
        data-backdrop="false"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Sign Up Info"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                Two-Factor Authentication
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="ctr title-2">
                <img
                  src={TwoFactorIcon}
                  alt="Two Factor Authentication Badge"
                  title="Two Factor Authentication"
                />
                <div className="sp-margin4">
                  Sign Up for Two-Factor Authentication
                </div>
              </div>
              <div className="modal-content-body descript-p">
                <div className="sp-margin3 text-reg">
                  <p>
                    Two-factor Authentication enhances the security of your
                    users by providing additional authentication code to protect
                    their account.
                  </p>
                  Setting up Two-Factor Authentication for your organization
                  will provide the capability to enable any users in your
                  organization with this added security. Contact your account
                  manager to find out how to sign up.
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {processingDetails ? (
        <div
          className="modal fade show"
          id="detailsOrgModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="DetailsOrganization"
          aria-hidden="false"
          style={{ display: "block" }}
        >
          <div className="loading"></div>
        </div>
      ) : null}
    </div>
  );
};

export default DetailsOrg;
